import { IExecutionOptions, IQueryOptions } from '../../models/query';
import { BaseTransform } from './BaseTransform';
import { Query } from '../Query';
import { get } from '../../utils/get';
import { isNullOrUndefined } from '../../utils/typeChecks';
import { isArrayLike } from '../../utils/isArrayLike';

export class PivotTransform extends BaseTransform {
	execute(queryResponse: any, queryOptions: IQueryOptions, executionOptions: IExecutionOptions) {
		const response: any[] = [];
		if (queryResponse) {
			if (isArrayLike(queryResponse) || typeof queryResponse === 'object') {
				let elements = queryResponse;
				if (!isArrayLike(queryResponse)) {
					elements = [queryResponse];
				}
				if (elements.length > 0) {
					response.push(...this.pivotElement(elements, executionOptions));
				}
			}
		}
		return response;
	}

	pivotElement(elements: object[], executionOptions: IExecutionOptions) {
		const { fields, pivotKey, pivotValueType, rawFieldKeys } = this.options;
		const response: any[] = [];
		const keysToRemove: string[] = [];
		for (const field of fields) {
			let fieldHasValue = false;
			const { key, name, isPrimary } = field;
			let nameValue = key;
			if (name) {
				const nameQuery = new Query(name);
				nameValue = nameQuery.execute(executionOptions);
			}
			const record: object = {
				name: nameValue,
			};

			for (const element of elements) {
				if (rawFieldKeys) {
					for (const rawFieldKey of rawFieldKeys) {
						record[rawFieldKey] = get(element, rawFieldKey);
					}
				}
				const fieldKey = get(element, pivotKey);
				if (!keysToRemove.includes(fieldKey)) {
					let fieldValue = get(element, key);
					if (pivotValueType) {
						if (pivotValueType === 'number') {
							fieldValue = parseFloat(fieldValue);
						}
						if (pivotValueType === 'string') {
							fieldValue = fieldValue.toString();
						}
					}
					if (!isNullOrUndefined(fieldValue) && !Number.isNaN(fieldValue)) {
						fieldHasValue = true;
						record[fieldKey] = fieldValue;
					}
					else if (isPrimary) {
						keysToRemove.push(fieldKey);
					}
				}
			}
			if (fieldHasValue) {
				response.push(record);
			}
		}
		// This will track all fields that are undefined or null for the primary record
		// If the primary record doesn't have a value then we ignore the values for the
		// other records. Usually needed when a fund does not have a value but its benchmarks
		// but we don't want to show the benchmark values then.
		if (keysToRemove && keysToRemove.length > 0) {
			const staticKeys = ['name', ...rawFieldKeys];
			for (let i = 0; i < response.length; i++) {
				const record = response[i];
				for (const keyToRemove of keysToRemove) {
					delete record[keyToRemove];
				}
				const remainingKeys = Object.keys(record);
				let hasValue = false;
				for (const remainingKey of remainingKeys) {
					hasValue = !staticKeys.includes(remainingKey);
					if (hasValue) {
						break;
					}
				}
				if (!hasValue) {
					response.splice(i, 1);
					i--;
				}
			}
		}
		return response;
	}
}